var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tabs" },
    _vm._l(_vm.tabList, function(item) {
      return _c(
        "span",
        {
          key: item.id,
          staticClass: "tab",
          class: { "active-tab": _vm.activeTab === item.id },
          on: {
            click: function($event) {
              return _vm.changeTab(item.id)
            }
          }
        },
        [_vm._v(_vm._s(item.name))]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6261480f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6261480f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tabs/tabs.vue
// module id = null
// module chunks = 